import { setWindowLocation, openInNewTab } from '@eb/http';
import { EVENTBRITE } from '../constants';

export const openEventUrl = (url, ticketsBy = EVENTBRITE) => {
    if (ticketsBy === EVENTBRITE) {
        setWindowLocation(url);
    } else {
        openInNewTab(url);
    }
};
